function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var utils = require("../utils.js");
var priceTaxFeeAdjusterBase = /*#__PURE__*/function () {
  function priceTaxFeeAdjusterBase() {
    _classCallCheck(this, priceTaxFeeAdjusterBase);
    this.name = undefined;
    this.id = undefined;
    this.supplementalData = undefined;
    this.priority = undefined;
    this.roundByGroup = undefined;
    this.groupIdPath = undefined;
    this.componentFields = ["price", "tax", "fee"];
  }
  return _createClass(priceTaxFeeAdjusterBase, [{
    key: "calculate",
    value: function calculate() {
      throw "calculate function must be defined in child class";
    }
  }, {
    key: "setSupplementalData",
    value: function setSupplementalData(supplementalData) {
      this.supplementalData = supplementalData;
    }
  }, {
    key: "calculateInt",
    value: function calculateInt(purchases) {
      var _this = this;
      [true, false].forEach(function (refund) {
        var floatAmountSums = {};
        var intAmountSums = {};
        var referenceToLastOfGroup = {};
        purchases.forEach(function (p) {
          if (p.refund !== refund) {
            return;
          }
          (p.priceTaxFeeAdjustments || []).forEach(function (ptf) {
            if (ptf.name === _this.name) {
              if (_this.roundByGroup) {
                var groupid = utils.objectPath(ptf, _this.groupIdPath);

                // initialize the promo group aggregates if they are not yet initalized
                floatAmountSums[groupid] = floatAmountSums[groupid] || 0;
                intAmountSums[groupid] = intAmountSums[groupid] || 0;

                // calculate float sum
                var floatAmount = ptf[_this.roundByGroup];
                floatAmountSums[groupid] += floatAmount;
                var totalFloatAmount = floatAmountSums[groupid];

                // calculate potential int sum
                var intAmount = utils.round(floatAmount);
                var totalIntAmount = intAmountSums[groupid] + intAmount;
                var cumulativeDiscrepancy = utils.round(totalIntAmount - totalFloatAmount);

                // if the fractional sum reaches an integer, take the integer and add it to the int sum
                if (cumulativeDiscrepancy * Math.sign(cumulativeDiscrepancy) >= 1) {
                  intAmount -= cumulativeDiscrepancy;
                }
                intAmountSums[groupid] += intAmount;

                // save the float amount affectation in a new field for data preservation
                ptf[_this.roundByGroup + "Float"] = +floatAmount.toFixed(4);
                // set the rounded amount as the main amount affectation
                ptf[_this.roundByGroup] = intAmount;
                referenceToLastOfGroup[groupid] = ptf;
              }

              // trim off js floating-point errors from the Float values
              // and round off values that don't need rounding by group
              // tax- and fee-inclusive tax-price and fee-price pairs are handled below
              _this.componentFields.filter(function (f) {
                return f !== _this.roundByGroup;
              }).forEach(function (f) {
                ptf[f + "Float"] = +ptf[f].toFixed(4);
                ptf[f] = utils.round(ptf[f]);
              });
            }
          });
        });

        // add any final remainder > 0.5 as 1 to the last of each group
        for (var groupid in floatAmountSums) {
          var finalCumulativeDiscrepancy = floatAmountSums[groupid] - intAmountSums[groupid];
          referenceToLastOfGroup[groupid][_this.roundByGroup] = utils.round(referenceToLastOfGroup[groupid][_this.roundByGroup] + finalCumulativeDiscrepancy);
        }

        // make sure price matches tax/fee for tax/fee-inclusive items
        purchases.forEach(function (p) {
          (p.priceTaxFeeAdjustments || []).forEach(function (ptf) {
            if ((ptf.name === "tax" || ptf.name === "fee") && ptf.priceFloat) {
              ptf.price = -ptf[ptf.name];
              ptf.priceFloat = -ptf[ptf.name + "Float"];
            }
          });
        });
      });
    }
  }]);
}();
module.exports = priceTaxFeeAdjusterBase;